import { Icon, type IconProps } from './Icon';

/** Desktop application window: title bar with controls, a button and a text field inside. */
export function WindowIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <rect x="2" y="3" width="20" height="18" rx="2" />
      <path d="M2 8h20" />
      <path d="M16 5.5h.01M19 5.5h.01" />
      <rect x="6" y="11" width="12" height="3" />
      <path d="M6 18h5" />
    </Icon>
  );
}
